/**
 * Layout configuration - single source of truth for which routes use minimal shell (no nav).
 * Add paths here when a route should render without the main app navigation.
 */
export const PATHS_WITHOUT_NAV: readonly string[] = [
  '/',
  '/auth',
  '/auth/claim',
  '/auth/viewer-claim',
  '/auth/prospect-claim',
  '/admin/login',
  '/apply',
  '/app',
  '/view/targets',
  '/view/prospects',
];

/** Strip trailing slashes so `/apply/` matches `/apply`. */
function normalizePathForNav(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '');
}

export function shouldShowNav(pathname: string): boolean {
  const p = normalizePathForNav(pathname);
  if (PATHS_WITHOUT_NAV.includes(p)) return false;
  if (p.startsWith('/view/')) return false;
  if (p.startsWith('/auth/viewer-claim')) return false;
  if (p.startsWith('/auth/prospect-claim')) return false;
  return true;
}

/** Suppress GlobalChat on claim/viewer minimal shells. */
export function shouldShowGlobalChat(pathname: string): boolean {
  return shouldShowNav(pathname);
}

